module.exports = __webpack_public_path__ + "static/media/ori.4e092f47.png";